<div class="field-dialog__content__scroll logs">
  <div fxLayout="column" fxLayoutAlign="center center" class="p-24" *ngIf="!logsMapped.length">
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="font-size-32">history</mat-icon>
    </p>
    <span class="h3">{{ 'MAINTENANCES.TABS.LOGS.NO_HISTORIC' | translate }}</span>
  </div>
  <ng-container *ngIf="logsMapped.length">
    <div class="p-24">
      <div class="logs__select">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MAINTENANCES.TABS.LOGS.FILTER.TITLE' | translate }}</mat-label>
          <mat-select [formControl]="selectValue" data-cy="select-historic">
            <mat-select-trigger>
              <i class="angularjs-fuse-icon icon-clipboard-text"></i>
              <span [innerHTML]="selectValue.value.title" attr.data-cy="select-{{ selectValue.value.title }}"></span>
            </mat-select-trigger>
            <mat-option
              *ngFor="let selectOption of selectOptions; index as index"
              [value]="selectOption"
              [innerHTML]="selectOption.title"
              attr.data-cy="option-{{ selectOption.value }}"
            ></mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="p-24">
      <div *ngIf="logsMappedFiltered?.length">
        <ng-container *ngFor="let log of logsMappedFiltered; index as index">
          <div
            *ngIf="logsMappedFiltered[index - 1]?.dateCreatedAt !== log?.dateCreatedAt"
            class="log-date font-color-gray"
            attr.data-cy="log-date-{{ index }}"
          >
            <p *ngIf="log.dateCreatedAt === todayDate">
              {{ 'MAINTENANCES.TABS.LOGS.TIMELINE.TODAY' | translate }}
            </p>
            <p *ngIf="log.dateCreatedAt === yesterdayDate">
              {{ 'MAINTENANCES.TABS.LOGS.TIMELINE.YESTERDAY' | translate }}
            </p>
            <p *ngIf="log.dateCreatedAt !== yesterdayDate && log.dateCreatedAt !== todayDate">
              {{ log.dateCreatedAt }}
            </p>
          </div>

          <div class="log" attr.data-cy="historic-log-{{ index }}">
            <div class="log-icon-wrapper">
              <div class="log-icon {{ log.colorBackground }}">
                <img *ngIf="log.image" src="assets/images/icons/{{ log.image }}.svg" [alt]="log.eventName" />
                <i *ngIf="!log.image" class="angularjs-fuse-icon {{ log.icon }}"></i>
              </div>
              <span class="log-line"></span>
            </div>

            <div class="card mb-0">
              <div class="card__item mt-0">
                <div class="log-title">
                  <div class="log-title__description">
                    <span class="log-event-name" [innerHTML]="log.eventName"></span>
                  </div>
                  <div class="log-title__date font-color-gray">
                    {{ log.dateTimeCreatedAt }}
                  </div>
                </div>
                <div *ngIf="log.customAuthor && !log.isRateLog" class="log-author-and-device font-color-gray">
                  <mat-icon inline>{{ log.customAuthorDevice }}</mat-icon>
                  <span>{{ log.customAuthor }}.</span>
                </div>
                <div
                  *ngIf="log.isRateLog"
                  class="log-stars"
                  [ngClass]="{
                    'reasonable-stars--bold': log.snapshot.rating.stars === 3,
                    'positive-stars--bold': log.snapshot.rating.stars > 3,
                    'negative-stars--bold': log.snapshot.rating.stars < 3
                  }"
                >
                  <stars [stars]="log.snapshot.rating.stars"></stars>
                  <span *ngIf="log.snapshot.rating.stars <= 1" class="font-color-gray">
                    {{ log.snapshot.rating.stars }}
                    {{ 'MAINTENANCES.TABS.LOGS.TASK.STAR' | translate }}
                  </span>
                  <span *ngIf="log.snapshot.rating.stars > 1" class="font-color-gray">
                    {{ log.snapshot.rating.stars }}
                    {{ 'MAINTENANCES.TABS.LOGS.TASK.STARS' | translate }}
                  </span>
                </div>

                <div *ngIf="log.message && log.showMessage" class="log-description font-color-gray">
                  <p class="log-description--line-break" [innerHTML]="log.message"></p>
                </div>
                <div *ngIf="log.eventDescription" class="log-description font-color-gray">
                  <p [innerHTML]="log.eventDescription"></p>
                </div>
                <div *ngIf="log.eventNote" class="log-description font-color-gray">
                  <p [innerHTML]="log.eventNote"></p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
